import React, { useState } from "react";
import "./Forgot.css";
import login_logo from "../../../images/HOA Owl Logo.svg";
import { InputLabel, Input} from "@mui/material";
import { Button } from "@mui/material";
import chevronleft from "../../../images/chevronleft.svg";
import { useDispatch} from "react-redux";
import { userForgotPasswordApi } from "../../../Services/Login/LoginApi/loginApi";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function ForgotComp() {
  const [email, setEmail] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});



  const handleSubmit = async (e) => {
    e.preventDefault();

    // Email Validation (Only shows error below input)
    const newErrors = {};
    if (!email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "Invalid email format";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      return; //  Stop function execution if validation errors exist
    }

   

    //  API Call
    const result = await dispatch(userForgotPasswordApi({ email }));

    if (userForgotPasswordApi.fulfilled.match(result)) {
      toast.success("Password reset link sent successfully!");
      navigate(`/confirm-account-otp?email=${encodeURIComponent(email)}`);
    } else {
      const errorMessage = result.payload?.message || "Please enter the correct email!";
      toast.error(errorMessage); //  Show error in toast only
      console.error("Failed to submit email:", errorMessage);
    }
  }
 

  const handleBackClick = () => {
    navigate(-1); // Navigates to the previous page
  };

  return (
    <>
      <section className="login-page-one forgot-pw-section">
        <div className="container-fluid p-0">
          <div className="row m-0 row-forgotpw">
            <div className="col-md-6">
              <div className="banner-contents">
                <div className="banner-image">
                  {/* <img src={banner_img} alt="banner-image"></img> */}
                  <div className="text-overlay">
                  {/* <h5>Welcome Back!</h5>
                  <p>
                    Elevate your business insights with precision. Log in to
                    discover and refine your Ideal Customer Profiles
                    effortlessly.
                  </p> */}
                   <p>Creating customizable solutions for overall wellness</p>
                </div>
                </div>
               
              </div>
            </div>
            <div className="col-md-6 forgotpw-box">
              <div className="login-right-block">
                <div className="login-logoimg text-center forgotpw-block">
                  <img
                    src={login_logo}
                    alt="login-logo"
                    className="login_logo_img"
                  ></img>
                </div>
                <div className="back-btn">
                  <a href="javascript:void(0)" onClick={handleBackClick}>
                    <img
                      src={chevronleft}
                      alt="chevron-left"
                      class="left-icon"
                    ></img>
                    Back
                  </a>
                </div>
              </div>
              <div className="forgt-pw-block">
                <div className="login-information">
                  <h1 className="text-center m-0">Forgot Password</h1>
                  <p className="pw-texts text-center mt-1">
                    Please enter the email address associated with your account.
                  </p>
                  <div className="form-login text-left">
                    <div className="mb-4">
                      <InputLabel htmlFor="standard-adornment-email">
                        Business Email <span>*</span>
                      </InputLabel>
                      <Input
                        className="email-input-box"
                        id="standard-adornment-email"
                        type="email"
                        placeholder="Email"
                        onChange={(event) => setEmail(event.target.value)}
                      />
   {/*  Error Message Just Below Input */}
   {errors.email &&<p style={{ color: "red" }} className="text-red-500 text-sm">{errors.email}</p>}
       
                    </div>
                    <div className="btn-orange">
                      <Button onClick={handleSubmit}>Send Reset Code</Button>
                    </div>
                    <div className="lower-signup-text text-center">
                      {/* <p>
                        Need Help? <a href="">Click Here</a>
                      </p> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer/>
      </section>
      
    </>
  );
}

export default ForgotComp;
